import styles from './styles/Button.expandValuesList.module.scss';
import React from 'react';
import { Ssvg } from '../../../Components/react/Ssvg';
export const ButtonExpandValuesList = ({ expanded, onClick }) => (React.createElement("button", { className: `btn:cleared d:inline-flex ai:center fw:700 bdrs:1 trs:all:300 ${styles.button}`, onClick: onClick }, expanded
    ? React.createElement(React.Fragment, null,
        "SHOW LESS ",
        React.createElement(Ssvg, { icon: "#icon--arrow-up", className: styles.icon }))
    : React.createElement(React.Fragment, null,
        "SHOW MORE ",
        React.createElement(Ssvg, { icon: "#icon--arrow-down", className: styles.icon }))));
